import { toast, TypeOptions, Bounce } from "react-toastify";

const ToastMessage = (type: TypeOptions, message: string) => {
  return toast(message, {
    type,
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    transition: Bounce,
    closeButton: false,
    className: "z-[9999999]",
    style: { zIndex: 9999999 }
  });
};

export default ToastMessage;